import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
import { closingLines } from '../data/offer';
export function ClosingSection() {
  return <section className="bg-forest-800 py-16 sm:py-20" aria-labelledby="closing-title" data-id="element-51" data-mp="12slodzpkpx35">
      <div className="mx-auto max-w-4xl px-4" data-id="element-52" data-mp="xtqthzec0i2o">
        <div className="text-center" data-id="element-53" data-mp="xsz9llu3k8s8">
          <h2 id="closing-title" className="text-balance text-3xl font-extrabold leading-tight text-cream sm:text-4xl" data-id="element-54" data-mp="xw3ll5dt08tg">
            Next Monday you can keep improvising…
          </h2>
          <p className="mt-4 font-display text-2xl font-extrabold text-gold-400 sm:text-3xl" data-id="element-55" data-mp="17rojarbuamxe">
            Or you can enter your classroom fully prepared starting today.
          </p>
        </div>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3" data-id="element-56" data-mp="1hijewmaz6yvi">
          {closingLines.map((line, index) => <motion.li key={line} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-center gap-3 rounded-lg border-l-4 border-gold-500 bg-forest-900/50 px-4 py-3 text-sm font-semibold text-cream" data-id="element-57" data-mp="1vfetsvdwrkjh" data-mpi={index}>
              <ChevronRightIcon className="h-4 w-4 shrink-0 text-gold-400" aria-hidden="true" data-id="element-58" data-mp="2gcn243djuzsi" />
              {line}
            </motion.li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-2xl text-center" data-id="element-59" data-mp="2l9dqddzid1p0">
          <p className="leading-relaxed text-forest-100" data-id="element-60" data-mp="2q902tl7iidwr">
            This teacher ready won't make you a better educator. You're already an excellent educator.
          </p>
          <p className="mt-3 text-lg font-bold text-cream" data-id="element-61" data-mp="300dy1gsfkrk3">
            What this teacher ready does is give you the time and tools so that excellence shows in every single class.
          </p>
        </div>
      </div>
    </section>;
}